<div>
    <canvas #canvas width="300" height="200"
            (mousedown)="startDrawing($event)"
            (mousemove)="draw($event)"
            (mouseup)="stopDrawing()"
            (mouseleave)="stopDrawing()"
            (touchstart)="startDrawing($event)"
            (touchmove)="draw($event)"
            (touchend)="stopDrawing()"></canvas>
</div>
<div class="flex flex-row gap-2 justify-center" style="width: 300px;">
    <button mat-button *ngIf="signatureIntroduced" (click)="clearCanvas()">
        <mat-icon
            color="warn"
            class="icon-size-8"
            [svgIcon]="'mat_outline:clear'"></mat-icon>
        Șterge
    </button>
    <button mat-button *ngIf="signatureUpdated" (click)="sendSignature()">
        <mat-icon
            color="primary"
            class="icon-size-8"
            [svgIcon]="'mat_outline:done'"></mat-icon>
        Gata
    </button>

</div>

<!--<button (click)="saveAsSvg()">Salvează ca SVG</button>-->
<!--<button (click)="logSignature()">Obține SVG</button>-->
<!--<button (click)="logSignature()">Verifica semnatura</button>-->
